import { useEffect } from "react"
import { useRouter } from "next/router"
import Error from "next/error"
import { useRecoilState } from "recoil"
import { isEmpty, compact } from "lodash"

import { Title } from "components/atoms/typography"
import ScreeningStepV2 from "components/templates/screening-step-v2"
import ScreeningOptionFormV2 from "components/organisms/screening-option-form-v2"

import { tenantScreeningStateV2 } from "stores/tenant-screening"
import { PATH } from "constants/route"
import { isUsState } from "utils/validations/property-validation"
import { isPartner } from "utils/partner"
import { httpStatusCode } from "constants/httpStatus"

export default function ScreeningPage(props) {
  const router = useRouter()
  const { partner } = router.query
  const [tenantScreeningV2, setTenantScreeningV2] = useRecoilState(tenantScreeningStateV2)

  useEffect(() => {
    if (props.screeningRequestProps) {
      setTenantScreeningV2({ ...props.screeningRequestProps })
    }
  }, [props.screeningRequestProps])

  const onSubmit = (data) => {
    const { screeningOption, payerType } = data
    setTenantScreeningV2({ ...tenantScreeningV2, screeningOption, payerType })
    router.push(`/${partner}/v2/${PATH.PROPERTY}`)
  }

  if (partner && !isPartner(partner)) {
    return <Error statusCode={httpStatusCode.NOT_FOUND} />
  }

  return (
    <ScreeningStepV2 mb="30">
      <Title size={"20px"} mt={"0"} mb={"20"}>
        Select screening items
      </Title>
      <ScreeningOptionFormV2
        partner={partner}
        value={tenantScreeningV2}
        onSubmit={onSubmit} />
    </ScreeningStepV2>
  )
}

export const getServerSideProps = (context) => {
  if (!isEmpty(context.query)) {
    const { agentEmail, renterEmails, partner, ...property } = context.query
    const { state, zip } = property

    if (!isUsState(state)) {
      delete property.state
    }

    if (isNaN(zip) || zip.length !== 5) {
      delete property.zip
    }

    const screeningRequestProps = {
      property: property || null,
      agentEmail: agentEmail || null,
      renterEmails: renterEmails ? compact(renterEmails.split(",")) : null,
    }
    return {
      props: { screeningRequestProps },
    }
  }
  return {
    props: {},
  }
}
